import React from 'react';
import { Target, Heart, Award, Users } from 'lucide-react';

export const AboutSection = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To make quality education accessible to every student by connecting them with the best tutors'
    },
    {
      icon: Heart,
      title: 'Our Values',
      description: 'We believe in personalized learning, trust, and building long-lasting educational relationships'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'We ensure all our tutors are verified, experienced, and committed to student success'
    },
    {
      icon: Users,
      title: 'Community',
      description: 'Building a strong community of learners, tutors, and institutions working together'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            About Avyudha
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Avyudha is India's leading tutor matching platform, dedicated to connecting students with qualified educators. 
            With over 7,000 tutors and serving 50,000+ students, we're transforming the way education is delivered.
          </p>
        </div>

        {/* Image and Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b"
              alt="About Avyudha"
              className="rounded-2xl shadow-lg w-full h-[400px] object-cover"
            />
          </div>
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900">
              Why Choose Avyudha?
            </h3>
            <p className="text-gray-600">
              Founded in 2022 and based in Bihar, India, Avyudha has quickly become the go-to platform for students seeking 
              quality tutoring services. Our comprehensive database includes expert tutors across all subjects, from school 
              curriculum to competitive exam preparation.
            </p>
            <p className="text-gray-600">
              We don't just connect you with tutors – we help you find the perfect match based on your learning style, 
              schedule, and educational goals. Whether you need help with academics, test prep, or skill development, 
              Avyudha has the right tutor for you.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <div className="bg-blue-50 px-4 py-2 rounded-lg">
                <p className="text-blue-600 font-semibold">✓ Verified Tutors</p>
              </div>
              <div className="bg-blue-50 px-4 py-2 rounded-lg">
                <p className="text-blue-600 font-semibold">✓ Flexible Scheduling</p>
              </div>
              <div className="bg-blue-50 px-4 py-2 rounded-lg">
                <p className="text-blue-600 font-semibold">✓ All Subjects</p>
              </div>
              <div className="bg-blue-50 px-4 py-2 rounded-lg">
                <p className="text-blue-600 font-semibold">✓ Affordable Rates</p>
              </div>
            </div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div key={index} className="text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon className="h-8 w-8 text-blue-600" />
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{value.title}</h4>
                <p className="text-gray-600 text-sm">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
